import { create } from "zustand";

interface ModalState {
  isCalendarModalOpen: boolean;
  openCalendarModal: () => void;
  closeCalendarModal: () => void;
}

export const useCalendarModal = create<ModalState>((set) => ({
  isCalendarModalOpen: false,
  openCalendarModal: () => set({ isCalendarModalOpen: true }),
  closeCalendarModal: () => set({ isCalendarModalOpen: false }),
}));